import { Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import { ModalService } from 'ng-bootstrap-modal';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SignupService } from '../signup/service/signup.service';
import { LocalStorageService } from '../common-service/local-storage/local-storage.service';
import { ServiceUrlsService } from '../common-service/service-urls/service-urls.service';


@Component({
  selector: 'app-ms-signup-dialog',
  templateUrl: './ms-signup-dialog.component.html',
  styleUrls: ['./ms-signup-dialog.component.scss']
})
export class MsSignupDialogComponent implements OnInit {

  // Microsoft Signup params

  msSignup =  true;
  isMsSignupError =  false;
  msSignUpErrorMessage : string;
  msSignupEmail: string;

  redirectUrl = 'https://executive-eye.com/ms-signup-response';


  constructor(private modalService:ModalService,
                  private signupService: SignupService,
                  private router: Router,
                  private activeRoute: ActivatedRoute,
                  private spinnerService: NgxSpinnerService,
                  private localStorageService: LocalStorageService,
                  private serviceUrlsService: ServiceUrlsService) { }

  ngOnInit() {
  }


  signUpWithMicrosoft() {
      this.isMsSignupError =  false;

      this.spinnerService.show();

       this.signupService.getMsAccessToken(this.msSignupEmail).subscribe(response => {
          let errorCodes = response.object.error_codes;
          console.log(response);

          console.log(errorCodes);
          if (errorCodes === undefined && !response.clientAlreadyRegistered) {
              //this.msSignUpErrorMessage = response.message;
              this.isMsSignupError =  false;

              const responseobjectBody = JSON.parse(response.object);

              console.log(responseobjectBody);

              this.localStorageService.saveMSAccessToken(responseobjectBody.access_token);
              //this.spinnerService.hide();
              console.log('inside if');

              this.sendAzureADInvitation();
              //Error Case
              // this.router.navigate(['signup-success', signupFormData.contactEmail]);
          } else {
              this.isMsSignupError =  true;
              this.msSignUpErrorMessage = response.message;
              console.log('inside else');
              this.spinnerService.hide();
              //this.spinnerService.hide();
          }
      },
        err => {

          console.log('inside error');
              console.log(err);
             this.isMsSignupError =  true;
             this.msSignUpErrorMessage = err.message;
             this.spinnerService.hide();
      });

    }

  sendAzureADInvitation() {

    console.log('inside ------ sendAzureADInvitation');

    this.spinnerService.show();

    const  msSigninRequestObject = {invitedUserEmailAddress: this.msSignupEmail,
                                    inviteRedirectUrl: this.serviceUrlsService.msRedirectUrl
                                   };
       this.signupService.sendAzureADInvitation(msSigninRequestObject).subscribe(response => {
          let errorCodes = response.error_codes;
          console.log(errorCodes)
          console.log(response);
          if (errorCodes === undefined || errorCodes === 'undefined') {

              this.isMsSignupError =  false;
              //this.msSignUpErrorMessage = response.message;
              const inviteRedeemUrl = response.inviteRedeemUrl
              const msUserDisplayName = response.invitedUserDisplayName;
              const msUserEmail = response.invitedUserEmailAddress;

              this.localStorageService.saveMSUserDisplayName(msUserDisplayName);
              this.localStorageService.saveMSUserEmail(msUserEmail);

              this.router.ngOnDestroy();
              window.open(inviteRedeemUrl, '_self');

              // this.router.navigate(['signup-success', signupFormData.contactEmail]);
          } else {
            this.msSignUpErrorMessage = response.message;
            this.isMsSignupError =  true;
            this.spinnerService.hide();
          }
      },
        err => {
              console.log(err);
             this.isMsSignupError =  true;
             this.msSignUpErrorMessage = err.message;
             this.spinnerService.hide();
      });
    }


  submit() {
       this.modalService.ok();

  }
  cancel() {
       this.modalService.cancel();
  }

  msSignUp() {

  }


}



// WEBPACK FOOTER //
// ./src/app/ms-signup-dialog/ms-signup-dialog.component.ts